import React from 'react';
import ListViewCard from '../../GigCards/ListViewCard';
import ListingsContainer from '../../GigCardListings/ListingsContainer';
import { withListingsTransformer } from '../../GigCardListings/hoc/withListingsTransformer';
import { ListViewListingPropTypes } from '../../GigCardListings/types/types';
import { LIST_VIEW_CARD, LISTINGS_CONTAINER_LIST_VIEW } from '../../GigCardListings/utils/constants';

const ListViewListings = ({
    gigs,
    gigImpression,
    onImpression,
    isTouch,
    tracking,
    size = 12,
    isLoading,
    lazyLoadOffset = 0,
    showTranslatedUGC,
    collectProps,
    banners,
    Wrapper,
    showFooter = true,
    container,
    listingsImpressionEnrichment,
    rollouts,
    excludedBadges = [],
}) => (
    <ListingsContainer
        className={LISTINGS_CONTAINER_LIST_VIEW}
        gigs={gigs}
        gigImpression={gigImpression}
        onImpression={onImpression}
        container={container}
        tracking={tracking}
        size={size}
        lazyLoadOffset={lazyLoadOffset}
        isLoading={isLoading}
        banners={banners}
        listingsImpressionEnrichment={listingsImpressionEnrichment}
        rollouts={rollouts}
        RenderGig={ListViewCard}
        renderGigProps={{
            ExternalWrapper: Wrapper,
            collectProps,
            isLoading,
            isTouch,
            showTranslatedUGC,
            showFooter,
            onImpression,
            excludedBadges,
        }}
    />
);

ListViewListings.propTypes = ListViewListingPropTypes;

export default withListingsTransformer(LIST_VIEW_CARD)(ListViewListings);
